/* eslint-disable no-unused-vars */
'use client';

import { Tab, TabGroup, TabList } from '@headlessui/react';
import Link from 'next/link';
import { useRouter, usePathname } from 'next/navigation';

import { classNames } from '@/shared/lib';

import { BottomMobileAccountTabsMenu } from './BottomMobileAccountTabs';

export const tabs = ['info', 'publications', 'pets', 'privacy-policy'] as const;
export type Tab = (typeof tabs)[number];

const MAP_TABS = {
  info: 'Данные',
  publications: 'Объявления',
  pets: 'Питомцы',
  'privacy-policy': 'Политика'
} satisfies { [key in Tab]: string };

export function AccountTabs() {
  const router = useRouter();
  const pathname = usePathname();
  const segments = pathname.split('/');
  const lastSegment = segments[segments.length - 1] as Tab;

  const _selectedTab = lastSegment ?? 'info';
  const selectedIndex = tabs.indexOf(_selectedTab) ?? 0;

  return (
    <>
      <div className="px-4 lg:block">
        <TabGroup
          vertical
          selectedIndex={selectedIndex}
          onChange={(index) => {
            const tab = tabs.at(index);
            router.replace(`/account/${tab}`, undefined);
          }}
        >
          <TabList className="flex w-auto flex-row gap-2 overflow-auto pb-4 lg:w-36 lg:min-w-[140px] lg:flex-col lg:pb-0">
            {tabs.map((tab, index) => (
              <Tab
                key={tab}
                as={Link}
                href={`/account/${tab}`}
                className={classNames(
                  index === selectedIndex ? 'bg-yellow-600 text-white' : 'bg-slate-200 text-black',
                  'h-auto rounded-md px-4 py-2 text-center lg:rounded-l-none lg:rounded-r-md'
                )}
                shallow
              >
                {MAP_TABS[tab]}
              </Tab>
            ))}
          </TabList>
        </TabGroup>
      </div>
      <BottomMobileAccountTabsMenu />
    </>
  );
}
